import { Box, Typography } from "@mui/material";
import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { makeStyles } from "@mui/styles";

function PageSection({ diablePrevious = false, onNextPress = () => { }, onPrevPress = () => { } }) {




  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "20px",
      }}
    >
      <div
        onClick={() => { !diablePrevious && onPrevPress() }}
      >


        <Box

          style={{
            border: "0.5px solid #E1E1E1",
            borderRadius: "18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
            margin: "2px",
            cursor: diablePrevious ? "auto" : "pointer",
          }}
        >
          <ChevronLeftIcon style={{ fontSize: "10px", color: diablePrevious ? '#d3d3d3' : 'black' }} />
          <Typography
            variant="h6"
            style={{
              fontSize: "8px",
              fontFamily: "DM Sans",
              lineHeight: "20px",
              fontWeight: "400",
              marginRight: "4px",
              color: diablePrevious ? '#d3d3d3' : 'black'
            }}
          >
            Previous
          </Typography>
        </Box>
      </div>
      <div
        onClick={onNextPress}
      >
        <Box
          style={{
            border: "0.5px solid #E1E1E1",
            borderRadius: "18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
            margin: "2px",
            cursor: "pointer",
          }}
        >
          <Typography
            variant="h6"
            style={{
              fontSize: "8px",
              fontFamily: "DM Sans",
              lineHeight: "20px",
              fontWeight: "400",
              marginLeft: "4px",
            }}
          >
            Next
          </Typography>
          <ChevronRightIcon style={{ fontSize: "10px" }} />
        </Box>
      </div>
    </Box>
  );
}

export default PageSection;
